import React, { useContext, useEffect } from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";

import BrokerDashboard from "area/broker/BrokerDashboard";
import Appearance from "components/Pages/Appearance";
import LogiqMindManager from "components/Pages/LogiqMindManager";
import Accounting from "area/broker/Accounting";
import Uploads from "area/broker/Uploads";
import Files from "area/broker/Files";
import Layout from "./Layout"
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

export default function BrokerRoutes() {
    const { setCompany } = useContext(PrivateRoutesContext);

    useEffect(() => {
        let selectedCompany = localStorage.getItem(`selectedCompanyId`);
        if (selectedCompany) {
            setCompany(selectedCompany)
        }

        document.title = "Align Admin FringeSecure | Broker";
    }, []);

    let { path, url } = useRouteMatch();
    return (
      <Layout >
        <Switch>
            <Route exact path={`${path}/`}>
                <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/dashboard`} component={BrokerDashboard} />
            <Route exact path={`${path}/appearance`} component={Appearance} />
            <Route exact path={`${path}/logiqmind-manager`} component={LogiqMindManager} />
            <Route exact path={`${path}/accounting`} component={Accounting} />
            <Route exact path={`${path}/uploads`} component={Uploads} />
            <Route exact path={`${path}/files`} component={Files} />
        </Switch>
      </Layout>
    )
}